var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tw-px-2 tw-text-gray-300"},[_vm._v("|")])}
var staticRenderFns = []

export { render, staticRenderFns }